import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Collapse, Input, Tag, Tooltip } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddKpiModal from "../../components/modal/add/AddKpiModal";
import CascadePlanModal from "../../components/modal/CascadePlanModal";
import SplitPlanModal from "../../components/modal/SplitPlanModal";
import Overview1 from "../../components/perf-cycle/Overview1";

const { Panel } = Collapse;

function SinglePlan() {
  const [addKpi, setAddKpi] = useState(false);
  const [cascade, setCascade] = useState(false);
  const [split, setSplit] = useState(false);
  const proHeight = document.body.clientHeight;

  const right = (
    <>
      <Tooltip title={"Delete"}>
        <Button danger className="mr-3">
          <DeleteOutlined />
        </Button>
      </Tooltip>
      <Tooltip title={"Edit"}>
        <Button className="mr-3">
          <EditOutlined />
        </Button>
      </Tooltip>
      <Tooltip title={"Help"}>
        <Button className="">
          <QuestionCircleOutlined />
        </Button>
      </Tooltip>
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">Plan</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <div className="flex justify-between w-full items-center mb-3">
            <div>
              <div className="flex items-center mb-1">
                <Tag color="blue">Objective</Tag>
                <Tag>Financial</Tag>
                <div className="text-xs text-gray-400">Jun 23 2022</div>
              </div>
              Revenue target for the financial year - 10 Million LKR
            </div>
            <div>
              <Tag color="Red">
                <div className="text-sm">10%</div>
              </Tag>
            </div>
          </div>

          <div className="mb-6 mt-6">
            <Overview1 />
          </div>

          <div className="text-xs">Target</div>
          <div className="mb-3">1,000,000 LKR / 10,000,000 LKR</div>

          <div className="flex items-center mb-3">
            <div>
              <Input placeholder="Amount" />
            </div>
            <div className="mx-3">/ 10000000</div>
            <Button htmlType="submit">Update</Button>
          </div>

          <div className="text-xs">Description</div>
          <div className="mb-3">
            This is the description of the objective assigned.
          </div>

          <div className="text-lg">KPIs</div>
          <div className="mb-5 max-w-4xl">
            <Collapse bordered={false}>
              <Panel
                header={
                  <div className="flex justify-between w-full">
                    <div>Acquisition of new customers - 5 Million LKR</div>
                    <div>
                      <Tag color="Red">10%</Tag>
                    </div>
                  </div>
                }
                key="1"
              >
                <div className="px-6">
                  <div className="flex items-center mb-3">
                    <div>
                      <Input placeholder="Amount" />
                    </div>
                    <div className="mx-3">/ 10000000</div>
                    <Button htmlType="submit">Update</Button>
                  </div>
                  <div>
                    <Button className="mr-2" danger>
                      <DeleteOutlined />
                    </Button>
                    <Button>
                      <EditOutlined />
                    </Button>
                  </div>
                </div>
              </Panel>
              <Panel
                header={
                  <div className="flex justify-between w-full">
                    <div>Cross selling - 5 Million LKR</div>
                    <div>
                      <Tag color="Red">10%</Tag>
                    </div>
                  </div>
                }
                key="2"
              >
                <div className="px-6">
                  <div className="flex items-center mb-3">
                    <div>
                      <Input placeholder="Amount" />
                    </div>
                    <div className="mx-3">/ 10000000</div>
                    <Button htmlType="submit">Update</Button>
                  </div>
                  <div>
                    <Button className="mr-2" danger>
                      <DeleteOutlined />
                    </Button>
                    <Button>
                      <EditOutlined />
                    </Button>
                  </div>
                </div>
              </Panel>
              <div className="py-3 px-4">
                <div
                  onClick={() => setAddKpi(true)}
                  className="cursor-pointer text-blue-500"
                >
                  + Add new KPI
                </div>
              </div>
            </Collapse>
          </div>
          <div className="flex justify-between">
            <div>
              <Button onClick={() => setCascade(true)} className="mr-2">
                Cascade
              </Button>
              <Button onClick={() => setSplit(true)} className="mr-2">
                Split
              </Button>
            </div>
          </div>
        </div>
      </Content>
      <AddKpiModal visible={addKpi} handleCancel={() => setAddKpi(false)} />
      <CascadePlanModal
        visible={cascade}
        handleCancel={() => setCascade(false)}
      />
      <SplitPlanModal visible={split} handleCancel={() => setSplit(false)} />
    </>
  );
}

export default SinglePlan;
